import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
export function SpecialOffer() {
  return <section id="offer" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-197">
      <div className="absolute inset-0 bg-stadium-glow opacity-80 pointer-events-none" data-id="element-198"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-199">
        <div className="max-w-4xl mx-auto" data-id="element-200">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-201">
            <div className="inline-block bg-red-600 text-white font-oswald uppercase tracking-widest px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-202">
              Launch Offer
            </div>
            <h2 className="font-anton text-5xl md:text-6xl text-white uppercase tracking-wide mb-4" data-id="element-203">
              SPECIAL OFFER
            </h2>
            <h3 className="font-oswald text-2xl md:text-3xl text-gold-500 uppercase tracking-widest" data-id="element-204">
              THE COMPLETE SYSTEM
            </h3>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-navy-950 border-2 border-gold-500/50 rounded-2xl p-6 md:p-12 shadow-[0_0_50px_rgba(239,43,45,0.18)] relative" data-id="element-205">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-navy-950 border-2 border-gold-500/50 px-6 py-2 rounded-full" data-id="element-206">
              <span className="font-anton text-xl text-gold-500 tracking-wider" data-id="element-207">
                72% OFF
              </span>
            </div>

            <div className="mb-10" data-id="element-208">
              <img src="https://cdn.magicpatterns.com/uploads/vF1P8TNmaRQc6eH9i9F9uw/ChatGPT_Image_19_jun_2026,_01_16_23.webp" alt="Basketball Ready System 365 Mockup" loading="lazy" decoding="async" className="w-full max-w-2xl mx-auto h-auto rounded-xl shadow-2xl" data-id="element-209" />
            </div>

            <div className="text-center mb-10" data-id="element-210">
              <div className="text-gray-400 font-oswald text-xl line-through mb-2" data-id="element-211">
                Regular Price: USD 97
              </div>
              <div className="text-gold-500 font-oswald text-2xl uppercase tracking-widest mb-2" data-id="element-212">
                Today Only:
              </div>
              <div className="font-anton text-7xl md:text-8xl text-white tracking-wider mb-4 drop-shadow-lg" data-id="element-213">
                USD 27
              </div>
              <p className="text-gray-400 text-sm" data-id="element-214">
                Pay securely in your local currency.
              </p>
            </div>

            <div className="bg-navy-900 border border-navy-700 rounded-xl p-6 mb-10" data-id="element-215">
              <div className="text-center mb-6" data-id="element-216">
                <span className="text-red-400 font-bold flex items-center justify-center gap-2" data-id="element-217">
                  <span className="animate-pulse" data-id="element-218">🔥</span>
                  Last Chance! This price increases when the countdown expires.
                </span>
              </div>
              <CountdownTimer data-id="element-219" />
            </div>

            <div className="flex flex-col items-center gap-6" data-id="element-220">
              <Button size="xl" fullWidth className="max-w-2xl" onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 27,
                currency: 'USD'
              });
              window.location.href = 'https://football-ready-system-365.impultienda.ar/checkout';
            }} data-id="element-221">
                YES, I WANT THE COMPLETE SYSTEM (USD 27)
              </Button>

              <div className="flex flex-col items-center gap-3" data-id="element-222">
                <div className="flex items-center gap-1" data-id="element-223">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-224" />)}
                  <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-225">
                    4.9/5 — Verified Reviews
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-226">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-227" />
                  <span data-id="element-228">7-Day Money Back Guarantee — Zero Risk</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}